var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GraficoPDF } from './GraficoPDF';
import * as helperPDF from '../../Biblioteca/helperPDF';
/**
 * Gera um componente para o PDF do gráfico de linha ou area
 */
export default class GraficoLinhaAreaPDF extends GraficoPDF {
    constructor(config, svg, title, legendData, sizeRow = 4, width = 105, height = 50, alignLegenda = 'center') {
        super(config, svg, title, legendData);
        this.sizeRow = sizeRow;
        this.width = width;
        this.height = height;
        this.alignLegenda = alignLegenda;
    }
    /**
     * Gera o componente do gráfico de linha ou area
     * @param docObj PDF
     *
     * @returns Promise<ComponentPDF | null> Componente do gráfico de linha ou area
     */
    criarGrafico(docObj) {
        return __awaiter(this, void 0, void 0, function* () {
            // estilos aplicados para a cell do texto da legenda
            const styles = {
                halign: 'left', valign: 'middle', cellWidth: 18
            };
            const body = helperPDF.formatLegendData(this.legendData, docObj.theme.lineChartColors, styles, this.sizeRow);
            const legenda = this.createOptionsTableLegend(body);
            return yield this.configurarGrafico(docObj, this.width, this.height, legenda, 'left', this.alignLegenda);
        });
    }
    /**
     * Cria os atributos da legenda para o jsPDF
     * @param body Corpo
     * @returns Configurações da legenda
     */
    createOptionsTableLegend(body) {
        const tableOptions = {
            body,
            head: [],
            bodyStyles: { fillColor: '#FFFFFF', valign: 'middle' },
            theme: 'plain',
            styles: {
                cellPadding: [1.5, 0]
            },
        };
        return tableOptions;
    }
}
